import { http, httpFile } from './http_service';

//Get all
export function all(){
    return http().get('/busuinessusepercentages');
}
//Get all active 
export function allActive(){
    return http().get('/busuinessusepercentages/active');
}
//Get Single
export function single(id){
    return http().get(`/busuinessusepercentages/${id}`);
}
//Add one
export function add(data){
    return http().post('/busuinessusepercentages', data)
}
//Update
export function update(id, data){
    return http().put(`/busuinessusepercentages/${id}`, data)
}
//Delete one
export function deleteSingle(id){
    return http().delete(`/busuinessusepercentages/${id}`);
}